import { KineticMarkerData } from '@kinetic-ui/shared';
import { Geometry } from '@turf/helpers';
import { SignMapEntity } from 'components/maps/markers/SignMarker';
import {
  CommunicationState,
  SignCapability,
  SignDisplayTypeFragment,
  SignQueuedMessageFragment,
} from '@kinetic-ui/data-layer';

const { MessagesGeneral, MessagesSpeedLimit, MessagesLaneControl, MessagesDualSpeedLimit } =
  SignCapability;

export interface StateLayerProps {
  signs: SignMapEntity[];
}

export type SignStateMapMarker = KineticMarkerData & StateMarkerProps;

export interface StateMarkerProps {
  location: { coordinates: [number, number] };
  communicationStatus?: CommunicationState;
  capability: SignCapability;
  layerActive: boolean;
  speedLimit?: number;
  direction: string;
  command?: string;
  active: boolean;
  id: string;
}

export enum StateLayerType {
  InactiveDualSpeedLimits = 'INACTIVE_DUAL_SPEED_LIMITS',
  ActiveDualSpeedLimits = 'ACTIVE_DUAL_SPEED_LIMITS',
  InactiveSpeedLimits = 'INACTIVE_SPEED_LIMITS',
  InactiveLaneControl = 'LANE_CONTROL_INACTIVE',
  ActiveSpeedLimits = 'ACTIVE_SPEED_LIMITS',
  ActiveLaneControl = 'LANE_CONTROL_ACTIVE',
  InactiveSigns = 'INACTIVE_SIGNS',
  ActiveSigns = 'ACTIVE_SIGNS',
}

export const StateLayersConfig = {
  [StateLayerType.InactiveSigns]: { capability: MessagesGeneral, active: false },
  [StateLayerType.ActiveSigns]: { capability: MessagesGeneral, active: true },
  [StateLayerType.InactiveSpeedLimits]: { capability: MessagesSpeedLimit, active: false },
  [StateLayerType.ActiveSpeedLimits]: { capability: MessagesSpeedLimit, active: true },
  [StateLayerType.InactiveLaneControl]: { capability: MessagesLaneControl, active: false },
  [StateLayerType.ActiveLaneControl]: { capability: MessagesLaneControl, active: true },
  [StateLayerType.InactiveDualSpeedLimits]: { capability: MessagesDualSpeedLimit, active: false },
  [StateLayerType.ActiveDualSpeedLimits]: { capability: MessagesDualSpeedLimit, active: true },
};

export interface SignMapEntityQueryType {
  active: boolean;
  communicationStatus?: CommunicationState;
  capabilities: SignCapability[];
  command: string | null;
  currentMessage?: SignQueuedMessageFragment | null;
  direction: string;
  displayType?: SignDisplayTypeFragment;
  fixedLocation: boolean;
  gantry: boolean;
  id: string;
  location: Geometry;
  name: string;
  speedLimit: number | null;
  systemEnabled: boolean;
}
